<template>
  <v-data-table ref="dataTable"
                :items="schaeden"
                :items-per-page="10"
                :headers="headers"
                :search="search"
                :custom-filter="customFilter(['Vertragsnummer', 'Kundenname', 'Schadennummer', 'Vertragstyp'])"
                :sort-by="'Meldedatum'"
                :sort-desc="true"
                :footer-props="footerProps"
                locale="de-DE"
                no-data-text="Keine Schäden vorhanden"
                no-results-text="Keine Schäden gefunden"
                must-sort
                class="schaden--table data--table">

    <!--- data rows ----------------------------------------------------------------------------->
    <template v-slot:item="{item}">

      <tr @click="$emit('show-damages', item.Vertragsnummer)">
        <td class="pl-large">
          <v-tooltip top nudge-bottom="8">
            <template v-slot:activator="{on}">
              <v-icon :color="getColor(item.Deckungszusage)"
                      v-on="on">
                {{ getIcon(item.Deckungszusage) }}
              </v-icon>
            </template>
            <span class="caption">{{ item.Deckungszusage }}</span>
          </v-tooltip>
        </td>
        <td>{{ item.erledigt | erledigtAsStatus }}</td>
        <td class="pl-large">{{ item.Vertragsnummer }}</td>
        <td class="single--line">{{ item.Kundenname }}</td>
        <td class="pl-large">{{ item.Schadennummer }}</td>
        <td>{{ item.Kosten | currency }}</td>
        <td>{{ item.Meldedatum | date }}</td>
        <td>{{ item.VertragsTyp | leistungsart }}</td>

        <td @click.stop>
          <v-menu :nudge-bottom="24"
                  bottom
                  left
                  content-class="table--actions">
            <template v-slot:activator="{on}">
              <v-icon v-on="on">more_vert</v-icon>
            </template>
            <v-list>
              <v-list-item @click="$emit('show-contract', item.Vertragsnummer )">
                <v-icon>insert_drive_file</v-icon>
                <v-list-item-title>Vertrag in Tab öffnen</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('show-damages', item.Vertragsnummer, true)">
                <v-icon>flash_on</v-icon>
                <v-list-item-title>Vertragsschäden in Tab öffnen</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </td>

      </tr>

    </template>

  </v-data-table>
</template>
<script>
import FiltersMixin from '@/components/kundenverwaltung/FiltersMixin';
import { FOOTER_PROPS } from './tableConfig';

export default {
  name: "SchaedenTable",
  mixins: [FiltersMixin],
  props: {
    schaeden: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      footerProps: FOOTER_PROPS,
      headers: [
        { text: 'Deckungszusage', value: 'Deckungszusage', sortable: true },
        { text: 'Status', value: 'erledigt', sortable: true },
        { text: 'Vertragsnummer', value: 'Vertragsnummer', sortable: true },
        { text: 'Kundenname', value: 'Kundenname', sortable: true },
        { text: 'Schadennummer', value: 'Schadennummer', sortable: true },
        { text: 'Bisherige Leistungen', value: 'Kosten', sortable: true },
        { text: 'Meldedatum', value: 'Meldedatum', sortable: true, class: Number },
        { text: 'Leistungsart', value: 'VertragsTyp', sortable: true },
        { text: '', value: 'newTab', sortable: false }
      ]
    };
  },
  methods: {
    getColor(value) {
      switch (value) {
        case 'Ja':
        case 'erteilt':
          return 'success';
        case 'Nein':
        case 'abgelehnt':
          return 'error';
        case 'offen':
          return 'inherit';
        default:
          return '';
      }
    },
    getIcon(value) {
      switch (value) {
        case 'Ja':
        case 'erteilt':
          return 'check';
        case 'Nein':
        case 'abgelehnt':
          return 'clear';
        case 'offen':
          return 'hourglass_empty';
        default:
          return '';
      }
    }
  }
};
</script>
<style>
.table-container .schaden--table.data--table .table tbody td.pl-large {
  text-align: left;
  padding-left: 30px !important;
}

.table-container .schaden--table.data--table .table tbody td.pl-small {
  text-align: left;
  padding-left: 24px !important;
}

</style>
